//src/components/onboarding/OnboardingHeader.tsx
import { Sparkles } from "lucide-react";
import { CardHeader, CardTitle } from "@/components/ui/card";
import welcomeImage from "./welcome_chat_image.png";

export function OnboardingHeader({ messages }) {
  return (
    <CardHeader
      className={`p-4 md:mt-[12px] ${messages.length === 1 ? "my-[130px]" : messages.length === 2 ? "my-[100px]" : "my-[60px]"} text-center`}
    >
      <div className="flex justify-center mb-2">
        <img src={welcomeImage} alt="Welcome png" className="h-60 w-auto" />
      </div>
      <div className="flex items-center justify-center">
        <Sparkles className="h-5 w-5 text-gray-700" />
        <CardTitle className="text-[22px] text-[#304145] font-semibold ml-2 mr-5">
          Welcome
        </CardTitle>
      </div>
      <p className="text-[18px] text-[#304145]">
        to your InMyNameKYC AI-powered onboarding assistant
      </p>
    </CardHeader>
  );
}
